<template>
    <div class="situation-panel">
        <div class="situation-title font-color">整体建设情况</div>
        <div class="situation-info-bar" v-for="(item,index) in infoData.baseInfo" :key="'baseInfo'+index">
            <div class="circle" :style="`background: ${item.color}`"></div>
            <div class="text">{{item.key}}</div>
            <div class="number font-color">{{$common.thousandBitSeparator(item.value)+item.unit}}</div>
        </div>
        <div class='chart' :id='"chart"' :style="{ width: '100%',height: '1.5rem'}"></div>
        <div class="line"></div>
        <div class="legend-box">
            <div class="legend-item"><div class="mark" style="background:#2899FF"></div>已建指标</div>
            <div class="legend-item"><div class="mark" style="background:#FFB11B"></div>超出规划</div>
            <div class="legend-item"><div class="mark" style="background:#989898"></div>规划指标</div>
        </div>
        <div class="situation-progressbar" v-for="(item,index) in infoData.indicatorComparison" :key="'indicatorComparison'+index">
            <div class="content">
                <div class="content-key">{{item.key}}:</div>
                <div class="content-value">
                    <span :style="{color:getProgressColor(item)}">{{item.unit&&item.unit==='㎡' ? $common.thousandBitSeparator(item.built)+item.unit : item.built+item.unit}}</span> 
                    <span style="color:#989898"> / {{item.unit&&item.unit==='㎡' ? $common.thousandBitSeparator(item.plan)+item.unit : item.plan+item.unit}}</span>
                </div>
            </div>
            <el-progress
                v-if="item.built!=='-'&&item.plan!=='-'"
                :stroke-width="10"
                :show-text="false"
                v-bind:style="{width: getProgressWidth(item)}"
                :percentage="getProgressValue(item)>=1 ? 100 : getProgressValue(item)*100"
                :color="getProgressColor(item)">
            </el-progress>
        </div>
        <div class="remainrule" v-for="(item,index) in infoData.remainingIndicators" :key="'remainingIndicators'+index">
            <span>{{item.k+":"}}</span><span class="font-color">{{item.unit&&item.unit==='㎡' ? $common.thousandBitSeparator(item.v)+item.unit : item.v}}</span>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: "BuildSituation",
    data() {
        return {
            infoData: {baseInfo:[],remainingIndicators:[],indicatorComparison:[]},
            percentage: 20,
            progressbarWidth: 200
        }
    },
    created() {
        this.getSummaryAxios()
    },
    methods: {
        ...mapActions('gisData', ['setGisSchemeAsync']),
        //获取整体建设信息
        getSummaryAxios() {
            let _this = this;
            let url = `${window.pubilc_config.digitalServerurl}/v1/digital/constructionSituation/summary`
            this.$common.getTokenRequest()
            .get(url)
            .then(res => {
              if (res.status === 200) {
                let data = res.data;
                if(data.code === 0) {
                    _this.infoData = data.data;
                    _this.drawChart()
                    let sheme = {
                        field: 'BLK',
                        colorInfo: {}
                    }
                    for(let item of data.data.baseInfo) {
                        for(let lot of item.lots) {
                            sheme.colorInfo[lot] = item.color
                        }
                    }
                    _this.setGisSchemeAsync(sheme)
                }
              }
            }).catch(err=>{
              console.log(err,'===/v1/digital/constructionSituation/summary')
            })
        },
        //计算进度条百分比
        getProgressValue(data) {
            return (data.built/data.plan);
        },
        //获取进度条颜色
        getProgressColor(data) {
            let percent = data.built/data.plan
            if(percent < 1) {
                return '#409eff';
            } else if(percent === 1) {
                return '#2EA86E';
            } else if(percent > 1) {
                return '#FFB11B';
            }
            return '#409eff';
        },
        //计算进度条长度
        getProgressWidth(data) {
            let percent = data.built/data.plan
            if(percent <= 1) {
                return this.progressbarWidth / 100 + 'rem';
            } else if(percent > 1 && percent <=1.3){
               return this.getProgressValue(data) * this.progressbarWidth / 100 + 'rem';
            } else {
                return 1.3 * this.progressbarWidth / 100 + 'rem';
            }
        },
        drawChart () {
            let chartData = this.infoData.baseInfo.map( item => {
                return {
                    value: item.value,
                    name: item.key
                }
            })

            // 基于准备好的dom，初始化echarts实例
            let chart = this.$echarts.init(document.getElementById('chart'))
            // 监听屏幕变化自动缩放图表
            window.addEventListener('resize', function () {
                chart.resize()
            })
            // 绘制图表
            chart.setOption({
                title: {
                    text: `建设情况`,
                    left: '46%',
                    top: '40%',
                    textAlign: 'center',
                    textStyle: {
                        fontSize: this.$common.fitChartSize(12),
                        fontWeight: 'bold',
                        color: '#FFFFFF',
                        textAlign: 'center',
                    },
                },
                grid: [{
                    left: 0,
                    right: 0,
                    top: 44,
                    bottom: 0
                }],
                color: ['#2EA86E', '#3A8FB7', '#C9D9E6'],
                series: [{
                    type: 'pie',
                    radius: ['40%', '72%'],
                    center: ['48%', '46%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: true,
                        formatter: '{d}%',
                        position: 'outside',
                        color: '#fff',
                        fontSize: this.$common.fitChartSize(12),
                        fontWeight: 'bold',
                        distanceToLabelLine: -20
                    },
                    labelLine: {
                        show: false
                    },
                    hoverAnimation: false,
                    data: chartData
                }]
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.situation-panel {
    width: 100%;
    .situation-title {
        font-size: 16px;
        font-family: SourceHanSansCN-Heavy;
        font-weight: 800;
        margin-bottom: 10px;
    }
    .situation-info-bar {
        display: flex;
        align-items: center;
        width: 100%;
        font-size: 14px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        color: #fff;
        margin: 10px 0;
        .circle {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin-right: 14px;
        }
        .text {
            width: 80px;
        }
        .number {
            flex: 1;
            text-align: right;
        }
    }
    .line {
        width: 260px;
        height: 1px;
        background: rgba(255, 255, 255, 0.3);
        margin-bottom: 20px;
    }
    .legend-box {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 10px 0 10px 0;
        .legend-item {
            width: 66px;
            font-size: 12px;
            font-family: SourceHanSansCN-Medium;
            font-weight: 500;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .mark {
                width: 12px;
                height: 12px;
            }
        }
    }
    .situation-progressbar {
        width: 100%;
        margin: 10px 0;
        .content {
            width: 100%;
            display: flex;
            align-items: center;
            color: #fff;
            font-size: 12px;
            font-family: SourceHanSansCN-Medium;
            font-weight: 500;
            margin-bottom: 2px;
            .content-key {
                width: 86px;
            }
            .content-value {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }
            span {
                color: #c9c7c7;
            }
        }
        /deep/ .el-progress-bar__outer {
            border-radius: 0;
            background-color: rgba(255,255,255,0.3);
        }
        /deep/ .el-progress-bar__inner {
            border-radius: 0;
        }
    }
    .remainrule {
        width: 100%;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #fff;
        font-size: 14px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        margin: 10px 0;
        :first-child {
            margin-top: 10px;
        }
    }
}
</style>